module.exports = __webpack_public_path__ + "static/media/rootcon.8b1d5f49.jpg";